export enum OutputPageType {
    Single,
    Multi
}
